"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="container-fluid">
    <div class="company-form-page">
      <div class="row">
        <div class="col-lg-${x => x.external === 'true' ? '12' : '8'} col-12 pb-lg-5">          
          ${T.when(x => x.external !== 'true', T.html `
            <div class="mb-2">
              <h1>${x => x.isEdit ? 'company.form.title.edit'.t() : 'company.form.title.add'.t()}</h1>
              <div class="text-zero top-right-button-container">
                <button @click="${(x, c) => x.cancel(c.event)}" type="button" class="top-right-button mr-1 btn btn-primary btn-lg">${'company.form.back'.t()}</button>
              </div>
            </div>
          `)}

          <div class="${x => x.external === 'true' ? '' : 'card card-body mb-5'}">
            <the-form @submit="${(x, c) => x.sendForm(c.event)}">
              <div class="form-group">
                <part-input 
                  required="true"
                  class="form-part"
                  label="${'company.form.name.label'.t()}"
                  :value="${x => x.form.name}"
                  name="name"
                  placeholder="${'company.form.name.placeholder'.t()}"
                ></part-input>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <part-input 
                    required="true"
                    class="form-part"
                    label="${'company.form.nip.label'.t()}"
                    :value="${x => x.form.nip}"
                    name="nip"
                    placeholder="${'company.form.nip.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-6">
                  <part-input 
                    required="true"
                    class="form-part"
                    label="${'company.form.email.label'.t()}"
                    :value="${x => x.form.email}"
                    name="email"
                    type="email"
                    placeholder="${'company.form.email.placeholder'.t()}"
                  ></part-input>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <part-input 
                    class="form-part"
                    label="${'company.form.phone.label'.t()}"
                    :value="${x => x.form.phone}"
                    name="phone"
                    placeholder="${'company.form.phone.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-6">
                  <part-input 
                    class="form-part"
                    label="${'company.form.website.label'.t()}"
                    :value="${x => x.form.website}"
                    name="website"
                    type="url"
                    placeholder="${'company.form.website.placeholder'.t()}"
                  ></part-input>
                </div>
              </div>
              <div class="form-group">
                <label>${'company.form.address.label'.t()}</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <part-input 
                      required="true"
                      class="form-part force-placeholder"
                      :value="${x => x.form.street}"
                      name="street"
                      placeholder="${'company.form.street.placeholder'.t()}"
                    ></part-input>
                  </div>
                  <div class="form-group col-md-3">
                    <part-input 
                      required="true"
                      class="form-part force-placeholder"
                      :value="${x => x.form.postalCode}"
                      name="postalCode"
                      placeholder="${'company.form.postal_code.placeholder'.t()}"
                    ></part-input>
                  </div>
                  <div class="form-group col-md-3">
                    <part-input 
                      required="true"
                      class="form-part force-placeholder"
                      :value="${x => x.form.city}"
                      name="city"
                      placeholder="${'company.form.city.placeholder'.t()}"
                    ></part-input>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <part-textarea 
                  class="form-part"
                  label="${'company.form.description.label'.t()}"
                  :value="${x => x.form.description}"
                  name="description"
                  placeholder="${'company.form.description.placeholder'.t()}"
                ></part-textarea>
              </div>

              
              ${T.when(x => x.external !== 'true', T.html `
                
                <div class="form-row">
                  
                  <div class="col-lg-6">
                    <div class="form-check mb-4">
                      <part-checkbox
                        class="form-part"
                        label="${'company.form.active.label'.t()}"
                        :value="${x => x.form.active}"
                        name="active"
                      ></part-checkbox>
                    </div>                  
                  </div>

                  
                  <div class="form-group col-lg-6">
                    <part-input 
                      class="form-part"
                      label="${'company.form.logo.label'.t()}"
                      :value="${x => x.form.logo}"
                      name="logo"
                      type="file"
                      accept="image/*"
                    ></part-input>
                  </div>
                </div>
        
              `)}

              <div class="d-flex justify-content-end">
                ${T.when(x => x.external === 'true', T.html `
                  <button @click="${(x, c) => x.cancel(c.event)}" type="button" class="btn btn-secondary mr-2">
                    ${'common.cancel'.t()}
                  </button>
                  <button @click="${(x, c) => x.sendForm(c.event)}" type="submit" class="btn btn-primary">
                    ${'company.form.submit.createCompanyData'.t()}
                  </button>
                `)}
                
                ${T.when(x => x.external !== 'true', T.html `
                  <button @click="${(x, c) => x.sendForm(c.event)}" type="submit" class="btn btn-primary" :disabled="${x => x.loading}">
                    ${x => x.isEdit ? 'company.form.submit.update'.t() : 'company.form.submit.create'.t()}
                  </button>
                `)}
              </div>
              
            </the-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.company-form-page .mb-2 {
  position: relative;
}
.company-form-page .mb-2 h1 {
  margin-bottom: 1.5rem;
  color: #333;
  display: inline-block;
}
.company-form-page .mb-2 .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
}
.company-form-page .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.company-form-page .form-part {
  margin-bottom: 1rem;
}
.company-form-page .form-group {
  margin-bottom: 1rem;
}
.company-form-page .form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.company-form-page .form-row .form-group {
  padding-right: 5px;
  padding-left: 5px;
}
.company-form-page .form-check {
  margin-bottom: 0.75rem;
}
.company-form-page .form-check .form-part {
  margin-bottom: 0.5rem;
}
.company-form-page .btn {
  min-width: 120px;
}
.company-form-page .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.company-form-page .col-lg-6, .company-form-page .col-md-6, .company-form-page .col-md-3 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 768px) {
  .company-form-page .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .company-form-page .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .company-form-page .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .company-form-page .col-lg-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
}`;
const shadowOptions = { "mode": "open" };
let CompanyForm = class CompanyForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.resources = {};
        this.roles = {};
        this.companyId = null;
        // New attribute for external mode
        this.external = 'false';
        this.form = {
            name: '',
            nip: '',
            email: '',
            phone: '',
            street: '',
            postalCode: '',
            city: '',
            address: '',
            website: '',
            description: '',
            modules: [],
            logo: '',
            active: true
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        this.companyId = (_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id;
        if (this.external !== 'true') {
            try {
                const meta = await this.apiService.back.get('acl-policy.meta');
                if (meta.success && meta.data) {
                    this.resources = meta.data.resources;
                    this.roles = meta.data.roles;
                }
            }
            catch (e) {
                console.error('Failed to load ACL meta data:', e);
            }
        }
        if (this.companyId && this.external !== 'true') {
            await this.loadCompany();
        }
        this.on(events_1.inputEvents.changed, (event) => {
            const key = event.detail.fieldName;
            if (key.startsWith('access.')) {
                return;
            }
            component_1.FormComponent.assignFormValues.bind(this)('form', event);
        });
    }
    async loadCompany() {
        if (!this.companyId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('company.get', {
                routeParams: { id: this.companyId }
            });
            if (response.success && response.data) {
                const company = response.data;
                this.form = {
                    name: company.name,
                    nip: company.nip || '',
                    email: company.email || '',
                    phone: company.phone || '',
                    street: company.street || '',
                    postalCode: company.postalCode || '',
                    city: company.city || '',
                    address: company.address || '',
                    website: company.website || '',
                    description: company.description || '',
                    modules: company.modules || [],
                    logo: company.logo || '',
                    active: company.active
                };
            }
            else {
                this.notifyService.notify(response.error || 'company.form.load.error'.t(), 'error');
            }
        }
        catch (e) {
            this.notifyService.notify('company.form.load.error'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        event.preventDefault();
        if (this.external === 'true') {
            if (!this.form.name || this.form.name.trim().length < 2) {
                this.notifyService.notify('company.form.name.label'.t() + ' ' + 'form.required'.t(), 'error'); // "Company Name Required"
                return;
            }
            if (!this.form.nip || this.form.nip.trim().length < 10) {
                this.notifyService.notify('company.form.nip.label'.t() + ' ' + 'form.required'.t(), 'error'); // "NIP Required"
                return;
            }
            if (!this.form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
                this.notifyService.notify('company.form.email.label'.t() + ' ' + 'form.required'.t(), 'error'); // "E-mail Required"
                return;
            }
            if (!this.form.street || !this.form.postalCode || !this.form.city) {
                this.notifyService.notify('company.form.address.label'.t() + ' ' + 'form.required'.t(), 'error'); // "Address Required"
                return;
            }
            this.$emit('company-form-submit', { company: this.form });
            return;
        }
        try {
            this.loading = true;
            let response;
            if (this.companyId) {
                response = await this.apiService.back.put('company.update', this.form, {
                    routeParams: { id: this.companyId }
                });
            }
            else {
                response = await this.apiService.back.post('company.create', this.form);
            }
            if (!response.success) {
                const errorMessage = response.error || (this.companyId ? 'company.form.submit.updateError'.t() : 'company.form.submit.createError'.t());
                this.notifyService.notify(errorMessage, 'error');
            }
            else {
                const successMessage = this.companyId ? 'company.form.submit.updateSuccess'.t() : 'company.form.submit.createSuccess'.t();
                this.notifyService.notify(successMessage, 'info');
                this.$emit('company-saved', { company: response.data });
                if (!this.companyId) {
                    // Reset form for add mode
                    this.form = {
                        name: '',
                        nip: '',
                        email: '',
                        phone: '',
                        street: '',
                        postalCode: '',
                        city: '',
                        address: '',
                        website: '',
                        description: '',
                        modules: [],
                        logo: '',
                        active: true
                    };
                    for (const formPart of this.$('.form-part')) {
                        formPart.reset();
                    }
                }
                component_2.SiteMenu.goto.bind(this)('/company/list');
            }
        }
        catch (e) {
            const errorMessage = this.companyId ? 'company.form.submit.updateError'.t() : 'company.form.submit.createError'.t();
            this.notifyService.notify(errorMessage, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    cancel(event) {
        event.preventDefault();
        if (this.external === 'true') {
            this.$emit('company-form-cancel');
            return;
        }
        component_2.SiteMenu.goto.bind(this)('/company/list');
    }
    get isEdit() {
        return !!this.companyId;
    }
};
exports.CompanyForm = CompanyForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CompanyForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], CompanyForm.prototype, "resources", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], CompanyForm.prototype, "roles", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CompanyForm.prototype, "companyId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CompanyForm.prototype, "external", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], CompanyForm.prototype, "form", void 0);
exports.CompanyForm = CompanyForm = __decorate([
    (0, client_1.RWSView)('company-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], CompanyForm);
CompanyForm.defineComponent();
